import { replacePathParams } from '@/api/utils';

export const partnerProvidersApiPaths = {
  list: '/facilityservice/supplementalliftproviders',
  partnerProviderById: '/facilityservice/supplementalliftproviders/:logisticProviderId',
} as const;

export const getPartnerProvidersApiUrl = {
  list: () => partnerProvidersApiPaths.list,
  logisticProviderById: (logisticProviderId: string) =>
    replacePathParams(partnerProvidersApiPaths.partnerProviderById, { logisticProviderId }),
};
